<script>
  import CloseButton from '@/_legacy/components/Modals/CloseButton.vue';
  import { InputField } from '@/ui/components/form';

  export default {
    name: 'ConductInspectionModalNotes',
    components: { CloseButton, InputField },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {
      text() {
        return this.$refs.notes?.$el.querySelector('textarea')?.value?.trim();
      },
    },
    async mounted() {
      await this.$nextTick();
      this.$refs.notes?.$el.querySelector('textarea')?.focus();
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      handleSave() {
        this.$emit('save', this.text);
      },
    },
  };
</script>

<template>
  <modal :clickaway-enabled="false" @modal-close="handleClose">
    <div class="modal-wrapper">
      <div class="modal-notes-header">
        <span class="modal-notes-title">
          {{ $t('inspection-conduct.text-comment') }}
        </span>
        <CloseButton @click="handleClose" />
      </div>

      <div class="modal-content">
        <InputField
          ref="notes"
          type="textarea"
          name="notes"
          :hide-label="true"
          :value="item.notes"
          :placeholder="$t('Enter notes here')"
        />
      </div>

      <div class="modal-actions-outer-wrapper">
        <div class="modal-actions-inner-wrapper">
          <button
            type="button"
            class="modal-actions-secondary"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </button>

          <button
            type="button"
            class="modal-actions-primary"
            @click.prevent="handleSave"
          >
            {{ $t('Save') }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
